<template>
  <div v-if="useUiStore().hasRequests" class="top-loader">
    <div class="loader"></div>
  </div>
</template>
<script setup lang="ts">
// let width = 100;
// const style = ref({
//   width: width + "%",
//   left: "0px",
//   right: "auto",
// });
// // increase the width of the loader infinitely in random intervals
// setInterval(() => {
//   if (width < 100) {
//     style.value.left = "0px";
//     style.value.right = "auto";
//     const min = 30;
//     const max = 80;
//     width = width + Math.ceil(Math.random() * (max - min) + min);
//     console.log({ width });
//     if (width >= 100) width = 100;
//   } else {
//     style.value.left = "auto";
//     style.value.right = "0px";
//     width = 0;
//   }
//   style.value.width = width + "%";
// }, 600);
</script>
<style lang="scss">
.top-loader {
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  width: 100%;
  height: 7px;
  background-color: var(--active);
}
.loader {
  background: var(--body-bg);
  position: fixed;
  z-index: 9999;
  top: 0;
  left: 0;
  height: 7px;
  width: 100%;
  background-color: var(--bt-active);
  animation: loader 1.2s infinite;
}
@keyframes loader {
  0% {
    width: 0;
    left: 0;
    right: auto;
  }
  50% {
    width: 100%;
    left: 0;
    right: auto;
  }
  51% {
    width: 100%;
    left: auto;
    right: 0;
  }
  100% {
    width: 0;
    left: auto;
    right: 0;
  }
}
</style>
